import moment from 'moment';
import { toast } from 'react-toastify';
import { allDays, fullDayName, month_names_short } from './constant';

export const isNumeric = (str) => {
  if (typeof str != 'string') return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
};

export const priceDecimal = (string) => {
  if (string !== null && string !== undefined) {
    string = string.toString().replace('.00', '');

    string += '';
    let x = string.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }

    return x1 + x2;
  } else {
    return '0';
  }
};

export const formatToCurrency = (value) => {
  const cleanValue = value.replace(/[^\d]/g, '');
  const formattedValue = new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(cleanValue);

  return formattedValue;
};

const defaultOption = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

const defaultOptionTime = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

/**
 * options => {
 *  day : numeric,
 *  month: long,
 *  year : numeric
 * }
 */
export const dateFormater = (date, options) => {
  if (!date) {
    return '-';
  }
  let now = new Date(Date.parse(date));
  if (!options) options = defaultOption;
  return now.toLocaleDateString('id-ID', options);
};

/**
 * options => {
 *  day : numeric,
 *  month: long,
 *  year : numeric,
 *  hour: '2-digit',
 *  minute: '2-digit'
 * }
 */
export const dateFormaterTime = (date, options) => {
  if (!date) {
    return '-';
  }
  let now = new Date(Date.parse(date));
  if (!options) options = defaultOptionTime;
  return now.toLocaleDateString('id-ID', defaultOptionTime);
};

export const labelToKey = ({ label = '' }) => {
  let key = label.toLowerCase().split(' ').join('_');
  return key;
};

export const timeDifference = (date) => {
  let now = Date.now();
  let parsedDate = Date.parse(date);
  const diffTime = Math.abs(parsedDate - now);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const formatShowDate = (date) => {
  let first = date.getDate();
  let last = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

  return `${first} - ${last} ${
    month_names_short[date.getMonth()]
  } ${date.getFullYear()}`;
};

export const reverseDateString = (date) => {
  if (typeof date === 'string' || date instanceof String) {
    date = Date.parse(date);
  } else if (typeof date == 'number') {
    date = new Date(date);
  }
  var dateStr = date.toLocaleDateString('id');
  return dateStr.split('/').reverse().join('-');
};

export const maritalStatusValue = (marital_status) => {
  if (!marital_status) return 1;
  let status = marital_status.toLowerCase();
  switch (status) {
    case 'divorce':
      return 3;
    case 'married':
      return 2;
    default:
      return 1;
  }
};

export const genderValue = (gender) => {
  if (!gender) return 0;
  let status = gender.toLowerCase();
  switch (status) {
    case 'male':
      return 0;
    case 'female':
      return 1;
    default:
      return 0;
  }
};

/**
 * Function returning the build date(as per provided epoch)
 * @param epoch Time in milliseconds
 */
export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format('DD-MM-YYY HH:MM');
  return buildDate;
};

export const differenceDateFromNow = (date) => {
  let difference = new Date(date).getTime() - new Date().getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
};

export const getCurrentTime = (date) => {
  let data = [
      [0, 4, 'Good night'],
      [5, 11, 'Good morning'],
      [12, 17, 'Good afternoon'],
      [18, 24, 'Good night'],
    ],
    hr = date.getHours();

  for (let i = 0; i < data.length; i++) {
    if (hr >= data[i][0] && hr <= data[i][1]) {
      return data[i][2];
    }
  }
};

export const readMore = (word, limit = 50) => {
  if (word.length > 50) {
    return `${word.slice(0, limit)}...`;
  }

  return word;
};

export const differenceDateUntilNow = (date) => {
  let difference = new Date().getTime() - new Date(date).getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays - 1;
};

export const generateStyle = (data) => {
  const { bgColor, textColor } = data;
  const style = {
    backgroundColor: bgColor,
    color: textColor,
  };

  return style;
};

export const getLocalStorage = (name, isObject = false) => {
  let data = localStorage.getItem(name);

  if (isObject) data = JSON.parse(data);

  return data;
};

export const setLocalStorage = (name, value) => {
  localStorage.setItem(name, value);

  return;
};

export const getIconFromOrg = (data, name) => {
  if (Object.keys(data).length > 0) {
    return data[name];
  }

  return null;
};

export const numberOnly = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

export const checkValidation = (payloads) => {
  let result = true;

  for (const data in payloads) {
    if (!payloads[data]) {
      toast.error(`${data} Wajib diisi`, {
        position: toast.POSITION.BOTTOM_LEFT,
      });

      result = false;
    }
  }

  return result;
};

export const getYear = (date) => {
  let year = date.getFullYear();
  return year;
};

export const getMonthYear = (date) => {
  console.log('datEE: ', date);
  let listMonth = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  let month = date.getMonth();
  let year = date.getFullYear();
  return `${listMonth[month]} ${year}`;
};

export const parseDate = (input) => {
  let parts = input.split('-');
  return new Date(parts[0], parts[1] - 1, parts[2]);
};

export const getDates = (startDate, endDate) => {
  let dates = [];
  let currentDate = parseDate(startDate);
  endDate = parseDate(endDate);

  while (currentDate <= endDate) {
    let final =
      currentDate.getFullYear() +
      '-' +
      (currentDate.getMonth() + 1 < 10 ? '0' : '') +
      (currentDate.getMonth() + 1) +
      '-' +
      (currentDate.getDate() < 10 ? '0' : '') +
      currentDate.getDate();
    dates.push(final);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
};

export const getDayName = (dateString, type) => {
  let d = new Date(dateString);
  if (type === 'fullName') {
    let dayName = fullDayName[d.getDay()];
    return dayName;
  } else {
    let dayName = allDays[d.getDay()];
    return dayName;
  }
};

export const dateFormat = (date) => {
  let result = moment(date).format('YYYY-MM-DD');
  return result;
};

export const capitalize = (str) => {
  if (str) {
    let lowerStr = str.toLowerCase();
    return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
  }
};

export const getWeek = (strDate) => {
  let currentDate = moment().toDate(strDate);
  let startDate = moment().toDate(currentDate.getFullYear(), 0, 1);
  let days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));
  let weekNumber = Math.ceil((days + 1) / 7);
  return weekNumber;
};

export const getFullWeeksStartAndEndInMonth = (month, year) => {
  let weeks = [],
    firstDate = moment().toDate(year, month, 1),
    lastDate = moment().toDate(year, month + 1, 0),
    numDays = lastDate.getDate();

  let start = 1;
  let end;
  if (firstDate.getDay() === 1) {
    end = 7;
  } else if (firstDate.getDay() === 0) {
    let preMonthEndDay = moment(new Date(year, month, 0)).toDate();
    start = preMonthEndDay.getDate() - 6 + 1;
    end = 1;
  } else {
    let preMonthEndDay = moment(new Date(year, month, 0)).toDate();
    start = preMonthEndDay.getDate() + 1 - firstDate.getDay() + 1;
    end = 7 - firstDate.getDay() + 1;
    weeks.push({
      start: start,
      end: end,
    });
    start = end + 1;
    end = end + 7;
  }
  while (start <= numDays) {
    weeks.push({
      start: start,
      end: end,
    });
    start = end + 1;
    end = end + 7;
    end = start === 1 && end === 8 ? 1 : end;
    if (end > numDays && start <= numDays) {
      end = end - numDays;
      weeks.push({
        start: start,
        end: end,
      });
      break;
    }
  }
  return weeks.map(({ start, end }, index) => {
    const sub = +(start > end && index === 0);
    return Array.from({ length: 7 }, (_, index) => {
      const date = moment(new Date(year, month - sub, start + index)).toDate();
      return {
        date: date.getDate(),
        month: date.toLocaleString('en', { month: 'long' }),
        day: date.toLocaleString('en', { weekday: 'long' }),
      };
    });
  });
};
